import { z } from "zod";

import {
  AliasKeySchema,
  BoardProfileSchema,
  CURRENT_PROTOCOL_VERSION,
  IsoTimestampSchema,
  PositionIdSchema,
  RelativePathSchema,
  RuntimeNameSchema,
  SessionKeySchema,
} from "./common.js";

export const BoardStatusSchema = z.enum(["creating", "ready", "corrupted"]);
export type BoardStatus = z.infer<typeof BoardStatusSchema>;

export const BoardVersionSchema = z.object({
  package: z.string().min(1),
  protocol: z.literal(CURRENT_PROTOCOL_VERSION),
});
export type BoardVersion = z.infer<typeof BoardVersionSchema>;

export const BoardMetadataSchema = z.object({
  branch: z.string().optional(),
  createdAt: IsoTimestampSchema,
  cwd: z.string(),
  dict: z.record(AliasKeySchema, RelativePathSchema),
  gitDir: z.string().optional(),
  profile: BoardProfileSchema,
  projectRoot: z.string(),
  rootPositionId: PositionIdSchema,
  runtime: RuntimeNameSchema,
  selectedPositionId: PositionIdSchema.optional(),
  sessionKey: SessionKeySchema,
  status: BoardStatusSchema,
  tipPositionId: PositionIdSchema,
  updatedAt: IsoTimestampSchema,
  version: BoardVersionSchema,
});
export type BoardMetadata = z.infer<typeof BoardMetadataSchema>;
